import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';
import { relationshipContactsApi } from '@/features/relationshipContacts/relationshipContactsApi';
import { refreshTypesenseTables } from '@/features/table/refreshTypesenseTables';

export const relationshipCompaniesApi = createApi({
	reducerPath: 'relationshipCompaniesApi',
	tagTypes: ['RELATIONSHIP_COMPANY'],
	baseQuery: fetchBaseQuery({
		...BASE_QUERY,
		baseUrl: process.env.REACT_APP_RELATIONSHIP_COMPANY_API,
	}),
	endpoints: (builder) => ({
		getRelationshipCompany: builder.query({
			providesTags: (result, error, relationshipCompanyId) => [
				{ type: 'RELATIONSHIP_COMPANY', id: relationshipCompanyId },
			],
			query: (relationshipCompanyId) => ({
				url: '/relationshipCompanies/get',
				method: 'POST',
				body: { relationshipCompanyId },
			}),
			transformResponse: (response) => response?.data,
		}),
		createRelationshipCompany: builder.mutation({
			query: ({ relationshipContactId, contact, ...company }) => ({
				url: '/relationshipCompanies/create',
				method: 'POST',
				body: { relationshipContactId, contact, ...company },
			}),
			transformResponse: (response) => response?.data,
			onQueryStarted: async ({ relationshipContactId }, { dispatch, queryFulfilled }) => {
				try {
					const { data } = await queryFulfilled;
					if (data?.id) {
						dispatch(
							relationshipCompaniesApi.util.upsertQueryData(
								'getRelationshipCompany',
								data.id,
								data,
							),
						);
					}
					const contactId = relationshipContactId ?? data?.relationshipContactId;
					if (contactId) {
						dispatch(
							relationshipContactsApi.util.invalidateTags([
								{ type: 'RELATIONSHIP_CONTACT', id: contactId },
							]),
						);
					}
					refreshTypesenseTables(dispatch);
				} catch {
					//
				}
			},
		}),
		updateRelationshipCompany: builder.mutation({
			query: ({ relationshipCompanyId, properties }) => ({
				url: '/relationshipCompanies/update',
				method: 'POST',
				body: { relationshipCompanyId, properties },
			}),
			transformResponse: (response) => response?.data,
			onQueryStarted: async ({ relationshipCompanyId }, { dispatch, queryFulfilled }) => {
				try {
					const { data } = await queryFulfilled;
					if (data) {
						dispatch(
							relationshipCompaniesApi.util.upsertQueryData(
								'getRelationshipCompany',
								relationshipCompanyId,
								data,
							),
						);
					}
					refreshTypesenseTables(dispatch);
				} catch {
					//
				}
			},
		}),
	}),
});

export const {
	useGetRelationshipCompanyQuery,
	useLazyGetRelationshipCompanyQuery,
	useCreateRelationshipCompanyMutation,
	useUpdateRelationshipCompanyMutation,
} = relationshipCompaniesApi;
